/*
 * NORA PRO: attach an SDS to the Request a Quote form.
 * The file goes to the sds-upload Cloudflare Worker (workers/sds-upload in the main repo), which checks
 * it (PDF, JPG or PNG only, no scripts, attachments or passwords) and stores it for 30 days. The form then
 * carries a private download link in the field "SDS file", so it arrives in the normal quote email.
 * Nothing shows unless the Worker answers that uploads are on, so the form never breaks.
 */
(function () {
  'use strict';
  var box = document.getElementById('nora-sds');
  if (!box) return;
  var endpoint = String(box.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
  if (!/^https:\/\/[a-z0-9.-]+(:\d+)?$/i.test(endpoint)) return;
  var form = document.getElementById(box.getAttribute('data-form') || 'contact_form');
  if (!form || !form.querySelector('[type="submit"]')) return;
  var email = box.getAttribute('data-email') || 'info@norapro.com.au';
  var MAX_FILES = 3;
  var MAX_BYTES = 5 * 1024 * 1024;
  var OK_TYPES = /\.(pdf|jpe?g|png)$/i;
  var files = [];
  var busy = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function kb(n) { return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'; }
  function track(result) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'sds_upload', sds_result: result }); } catch (e) { /* never break the form */ }
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'nora-sds';
    wrap.innerHTML =
      '<span class="nora-sds__label" id="nora-sds-label">Safety Data Sheet (SDS), optional</span>' +
      '<p class="nora-sds__help" id="nora-sds-help">Attach the SDS for your chemical and we will match the seal from it. PDF, JPG or PNG, up to 5 MB, ' + MAX_FILES + ' files at most.</p>' +
      '<label class="nora-sds__pick"><input type="file" id="nora-sds-input" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" multiple aria-labelledby="nora-sds-label" aria-describedby="nora-sds-help">' +
      '<span class="nora-sds__btn" aria-hidden="true">Choose file</span></label>' +
      '<ul class="nora-sds__list" id="nora-sds-list"></ul>' +
      '<p class="nora-sds__msg" id="nora-sds-msg" role="status" aria-live="polite"></p>';
    var submit = form.querySelector('[type="submit"]');
    var anchor = submit;
    while (anchor.parentNode && anchor.parentNode !== form) anchor = anchor.parentNode;
    form.insertBefore(wrap, anchor);
    return wrap;
  }

  var ui;
  function el(id) { return ui.querySelector('#' + id); }
  function say(text, tone, withEmail) {
    var m = el('nora-sds-msg');
    m.setAttribute('data-tone', tone || '');
    m.innerHTML = esc(text) + (withEmail ? ' <a href="mailto:' + esc(email) + '?subject=' + encodeURIComponent('SDS for my quote request') + '">' + esc(email) + '</a>' : '');
  }

  function sync() {
    Array.prototype.forEach.call(form.querySelectorAll('input[data-nora-sds]'), function (i) { i.parentNode.removeChild(i); });
    files.forEach(function (f, n) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.setAttribute('data-nora-sds', '');
      h.name = 'contact[SDS file' + (files.length > 1 ? ' ' + (n + 1) : '') + ']';
      h.value = f.name + ' (' + kb(f.size) + ', checked): ' + f.url;
      form.appendChild(h);
    });
    el('nora-sds-list').innerHTML = files.map(function (f, n) {
      return '<li><span class="nora-sds__ok" aria-hidden="true">&#10003;</span><span class="nora-sds__name">' + esc(f.name) + ' <small>' + esc(kb(f.size)) + ', checked and attached</small></span>' +
        '<button type="button" class="nora-sds__rm" data-rm="' + n + '" aria-label="Remove ' + esc(f.name) + '">Remove</button></li>';
    }).join('');
    var input = el('nora-sds-input');
    input.disabled = files.length >= MAX_FILES || busy > 0;
    ui.querySelector('.nora-sds__btn').textContent = files.length ? 'Add another file' : 'Choose file';
  }

  function send(file) {
    busy += 1;
    sync();
    say('Checking ' + file.name + '…', '');
    return fetch(endpoint + '/api/upload', {
      method: 'POST',
      headers: { 'content-type': 'application/octet-stream', 'x-file-name': encodeURIComponent(file.name.slice(0, 200)) },
      body: file,
      credentials: 'omit',
    }).then(function (r) { return r.json(); }).then(function (b) {
      if (b && b.ok && typeof b.url === 'string' && b.url.indexOf(endpoint + '/f/') === 0) {
        files.push({ name: String(b.name || file.name).slice(0, 80), size: Number(b.size) || file.size, url: b.url });
        say('', '');
        track('ok');
      } else {
        say((b && typeof b.message === 'string' ? b.message.slice(0, 200) : 'The upload did not work.') + ' Email:', 'error', true);
        track((b && b.reason) || 'error');
      }
    }).catch(function () {
      say('The upload did not work. Please try again, or email the SDS to', 'error', true);
      track('network_error');
    }).then(function () {
      busy -= 1;
      sync();
    });
  }

  function onPick(e) {
    var picked = Array.prototype.slice.call(e.target.files || []);
    e.target.value = '';
    var room = MAX_FILES - files.length;
    if (picked.length > room) say('You can attach up to ' + MAX_FILES + ' files. The rest can go by email to', 'warn', true);
    var chain = Promise.resolve();
    picked.slice(0, room).forEach(function (f) {
      if (f.size > MAX_BYTES) { say(f.name + ' is over 5 MB. Please email it to', 'error', true); track('too_big'); return; }
      if (!OK_TYPES.test(f.name)) { say('Please attach a PDF, JPG or PNG. Other files can go by email to', 'error', true); track('wrong_type'); return; }
      chain = chain.then(function () { return send(f); });
    });
  }

  function start() {
    ui = build();
    el('nora-sds-input').addEventListener('change', onPick);
    ui.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('[data-rm]');
      if (!rm) return;
      files.splice(Number(rm.getAttribute('data-rm')), 1);
      say('Removed.', '');
      sync();
    });
    form.addEventListener('submit', function (e) {
      if (busy > 0) { e.preventDefault(); say('Please wait until the SDS has been checked, then send the form.', 'warn'); }
    });
    sync();
  }

  // Only show the box when the Worker is up and switched on.
  var ctl = typeof AbortController === 'function' ? new AbortController() : null;
  var t = setTimeout(function () { if (ctl) ctl.abort(); }, 5000);
  fetch(endpoint + '/api/status', { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
    .then(function (r) { return r.json(); })
    .then(function (s) { clearTimeout(t); if (s && s.enabled === true) start(); })
    .catch(function () { clearTimeout(t); });
})();
